import { slugs } from '@/constants'

export const JOIN_THE_ADVENTURE_PROJECTS = [slugs.tuttleTwins, slugs.wingfeatherSaga, slugs.youngDavid]
